<section fxLayout="column">
  <div fxLayout="row" fxLayoutGap="20px">
    <mat-form-field>
      <mat-label>Numéro</mat-label>
      <input type="text" matInput [value]="pgm.numero.toString()" readonly />
    </mat-form-field>
    <mat-form-field fxFlex="100">
      <mat-label>Description</mat-label>
      <input type="text" matInput [value]="pgm.description" readonly />
    </mat-form-field>
    <mat-form-field fxFlex="100">
      <mat-label>Etat détaillé</mat-label>
      <input type="text" matInput [value]="pgm.descriptionEtatDetaille" readonly />
    </mat-form-field>
  </div>

  <mat-form-field>
    <mat-label>Commentaire</mat-label>
    <textarea matInput [value]="pgm.commentaire" readonly rows="2"></textarea>
  </mat-form-field>
</section>

<section class="liens">
  <span>PGM par AS</span>
  <div>
    <a mat-raised-button *ngFor="let url of pgm.lstUrlCreationPgm" color="primary" [href]="url.urlCreationPgm" target="_blank">
      {{ url.nomSousSysteme }}
    </a>
  </div>
</section>

<section class="title-segment">
  <span>Segments associés</span>
</section>

<section class="map">
  <kendo-grid
    #kendoGrid
    fxFlex="30"
    [data]="gridWrapper.gridData"
    kendoGridSelectBy="id"
    [selectable]="false"
    [height]="height"
    scrollable="virtual"
    rowHeight="54px"
    [skip]="gridWrapper.gridState.skip"
    [pageSize]="gridWrapper.gridState.take"
    [loading]="gridWrapper.loading"
    [sort]="gridWrapper.gridState.sort || []"
    (dataStateChange)="gridWrapper.onDataStateChange($event)"
  >
    <kendo-grid-column field="nomSegment" title="Numéro" width="100"> </kendo-grid-column>

    <kendo-grid-column field="descriptionTypes" title="Evènement">
      <ng-template kendoGridCellTemplate let-dataItem>
        <span [matTooltip]="dataItem.descriptionsTypeEs.join(',')">{{ dataItem.descriptionsTypeEs.join(',') }}</span>
      </ng-template>
    </kendo-grid-column>
  </kendo-grid>

  <div id="mapViewNode" #mapViewNode [style.height]="height + 'px'"></div>
</section>

<section class="area-footer">
  <button mat-raised-button color="accent" (click)="close()">Fermer</button>
</section>
